import classNames from "classnames";
import SearchBoxTabs from "./SearchBoxTabs";
import SearchBox from "./SearchBox";
import { useTheme } from "../../../theme/useTheme";
import { useExtraTab } from "@presentation/shared/context/extra-tab-context";

export default function SearchBoxHome() {
  const { searchBox } = useTheme();
  const { slug, config } = useExtraTab();

  return (
    <div className={classNames(searchBox.container)}>
      <SearchBoxTabs />
      {slug ? (
        config.type === "iframe" && (
          <iframe
            className="w-full min-h-[800px] border-0"
            src={config.url}
          ></iframe>
        )
      ) : (
        <div className={classNames(searchBox.form)}>
          <SearchBox />
        </div>
      )}
    </div>
  );
}
